import { render, staticRenderFns } from "./Userment.vue?vue&type=template&id=4c51a329&scoped=true&"
import script from "./Userment.vue?vue&type=script&lang=js&"
export * from "./Userment.vue?vue&type=script&lang=js&"
import style0 from "./Userment.vue?vue&type=style&index=0&id=4c51a329&scoped=true&lang=css&"
import style1 from "./Userment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c51a329",
  null
  
)

export default component.exports